"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.measureTextWidth = void 0;
var measureTextWidth = function measureTextWidth(text, containerFont) {
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  context.font = containerFont;
  return context.measureText(text).width;
};
exports.measureTextWidth = measureTextWidth;